import { Card, Stack, Switch, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { toggleVisibility } from "Redux/filtersSlice";
import { changeReportLeftSideMode } from "Redux/sideSlice";

export default function LeftSideItems() {
  const dispatch = useAppDispatch();

  const { reportLeftSideMode } = useAppSelector((state) => state.side);

  const handleClick = (key: string) => {
    dispatch(toggleVisibility(key));
  };

  const selectItem = (event: React.MouseEvent<HTMLElement>, newMode: number) => {
    if (newMode !== null) {
      dispatch(changeReportLeftSideMode(Number(newMode)));
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <ToggleButtonGroup value={Number(reportLeftSideMode)} onChange={selectItem} exclusive aria-label="survay-show-type">
          <ToggleButton
            value={1}
            aria-label="item-1"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: Number(reportLeftSideMode) === 1 ? "#4754CA" : "",
              color: Number(reportLeftSideMode) === 1 ? "#fff" : "",
            }}
          >
            داشبورد ستاره
          </ToggleButton>
          <ToggleButton
            value={2}
            aria-label="item-1"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: Number(reportLeftSideMode) === 2 ? "#4754CA" : "",
              color: Number(reportLeftSideMode) === 2 ? "#fff" : "",
            }}
          >
            جزییات مسافر
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Card>
  );
}
